<script>
  import { auth, db } from "../etc/firebase.js"
  import PrivatePage from "./PrivatePage.svelte"
  import Member from "./Member.svelte"
  import Notes from "./Notes.svelte"

  // Listen for auth status change
  let isLogin = false
  let memberList = []
  let guaList = []
  let totalMember = 0
  let totalGua = 0

  auth.onAuthStateChanged((user) => {
    if (user) {
      isLogin = true

      // get guaRecords data from Firebase db
      db.collection("guaRecords")
        .orderBy("recordDT")
        .onSnapshot((data) => {
          //  console.log(data.docs)
          guaList = data.docs
          totalGua = guaList.length
          // console.log(
          //   "@ XiYiAdmin inside getting from db: guaList is = " + guaList
          // )
        })

      // get member data from Firebase db
      db.collection("xiyiMembers")
        .orderBy("createdDT")
        .onSnapshot((data) => {
          // console.log(data.docs)
          memberList = data.docs
          totalMember = memberList.length
          // console.log(
          //   "@ XiYiAdmin inside getting from db: memberList is = " + memberList
          // )
        })

      //console.log("@ XiYiAdmin: memberList is = " + memberList)
    } else {
      isLogin = false
      // console.log(
      //   "@ XiYiAdmin: just logout. System will redirect user to Private page and asking for login first."
      // )
    }
  })
</script>

<main>
  {#if isLogin}
    <h3>XiYi Admin Page</h3>

    <!-- Manage News Release -->
    <h4>Manage News Release</h4>
    <Notes />

    <h4>Gua statistics (Total: {totalGua})</h4>
    <h6>Qi Gua Count in the past 30 days</h6>
    <h6>Qi Gua Count monthly chart</h6>
    <h6>Total and Newly added Member Count monthly chart</h6>

    <!-- Members LIST -->
    <h4>List of Members (Total: {totalMember})</h4>
    <div class="collection">
      {#each memberList as member}
        <Member id={member.id} member={member.data()} />
      {/each}
    </div>
  {:else}
    <PrivatePage />
  {/if}
</main>
